import React from 'react'
import { Button } from 'react-bootstrap'
import { IoChevronForwardOutline } from 'react-icons/io5';

const CustomButton = ({buttonText, buttonType, arrow,onClick}) => {
  return (
    <Button onClick={onClick} className={buttonType === "navBtn" ? 'main-btn navbtn' : buttonType === "bannerBtn" ? 'main-btn bannerBtn' : buttonType === "FooterBtn" ? 'main-btn footerBtn' : ''  } variant="" > <span>{buttonText}</span>  {arrow &&(<span className='arrow-animation'><IoChevronForwardOutline   /></span>)} </Button>
  )
}

export default CustomButton
